/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AuthGuard,
  CmsConfig,
  I18nModule,
  provideDefaultConfig,
} from '@lm-nx-frontend/lm-inf-core';
import { CardModule } from '@lm-nx-frontend/lm-inf-ui';
import { AccountSummaryHeaderComponent } from './account-summary-header.component';
import {AdminGuard} from "../../../../administration/core/guards";

export const accountSummaryHeaderCmsConfig: CmsConfig = {
  cmsComponents: {
    AccountSummaryHeaderComponent: {
      component: AccountSummaryHeaderComponent,
      guards: [AuthGuard, AdminGuard],
    },
  },
};

@NgModule({
  declarations: [AccountSummaryHeaderComponent],
  imports: [CardModule, CommonModule, I18nModule],
  providers: [provideDefaultConfig(accountSummaryHeaderCmsConfig)],
})
export class AccountSummaryHeaderModule {}
